module.exports = {
	title: 'gatsby-starter-i18n',
	logo: 'https://i18n.smakosh.com/favicon/logo-48.png',
	url: 'https://i18n.smakosh.com',
	favicon: 'https://i18n.smakosh.com/favicon/logo-48.png',
	cover: 'https://i18n.smakosh.com/cover.jpg',
	legalName: 'Ismail Ghallou',
	description: 'Gatsby starter with i18n and lot of other cool features',
	socialLinks: {
		twitter: 'https://twitter.com/smakosh',
		github: 'https://github.com/smakosh',
		linkedin: 'https://www.linkedin.com/in/ismail-ghallou-630149122/',
		instagram: 'https://www.instagram.com/smakosh19/',
		youtube: 'https://www.youtube.com/user/smakoshthegamer',
		google: 'https://plus.google.com/u/0/+IsmailSmakoshGhallou',
	},
	googleAnalyticsID: 'UA-88875900-1',
	themeColor: '#000696',
	backgroundColor: '#6496f6',
	social: {
		facebook: '165244147328608',
		twitter: '@smakosh'
	},
	address: {
		city: 'Errachidia',
		region: 'Drâa-Tafilalet',
		country: 'Morocco',
		zipCode: '52000'
	},
	contact: {
		email: 'ismai23l@hotmail.com',
		phone: '+212-663-53-27-61'
	},
	foundingDate: '2018',
	googleVerification: 'xxx'
}
